import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../../../Icon';
import Spinner from '../../../Spinner';
import Popover from '../../../Popover';
import styles from './SearchSelectionListInner.module.css';
import FilteredSelectInner from '../FilteredSelectInner';

const bindClasses = classNameBind.bind(styles);

const SearchSelectionListInner = ({
  items,
  onItemSelected,
  value,
  onFocus,
  onBlur,
  isFocused,
  isLoading,
} = {}) => {
  const isItemChecked = item => (
    value.some((selectedItem) => {
      if (selectedItem.id) {
        return selectedItem.id === (item.id || item.value);
      }

      return selectedItem.name === (item.name || item.value);
    }));

  const isItemInGroupChecked = itemGroup => itemGroup.some(
    item => (
      item.subItems && item.subItems.length > 0 ? isItemInGroupChecked(item.subItems) : isItemChecked(item)
    ),
  );

  const refs = {};

  const closeOtherElements = (id) => {
    Object.keys(refs).forEach((prop) => {
      if (prop !== id && refs[prop].current) {
        refs[prop].current.onToggle(false);
      }
    });
  };

  const generateItemInner = (item, checked, submenu) => (
    <li
      key={item.id ? item.id : item.name}
      className={bindClasses('item', { checked })}
    >
      <div className={bindClasses('item-ctn')}>
        <div className={bindClasses('item-text')}>
          <a
            onClick={!submenu ? () => { onItemSelected(item); } : () => {}}
            role="button"
            aria-hidden
          >
            {checked && (
            <span className={bindClasses('checkmark-ctn')}>
              <Icon name="checkmark" color="blue" />
            </span>
            ) }
            <span className={bindClasses({ selected: checked, 'not-selected': !checked, 'submenu-trigger': submenu })}>
              {item.name}
            </span>
            {Boolean(submenu) && (
              <span className={bindClasses('menu-icon-ctn')}><Icon name="chevron-right" color="gray" /></span>
            )}
          </a>
        </div>
        {item.rightButton && !submenu && (
          <div className={bindClasses('item-button')}>
            {item.rightButton}
          </div>
        )}
      </div>
    </li>
  );

  const generateItem = (item) => {
    if (item.subItems && item.subItems.length > 0) {
      const checked = isItemInGroupChecked(item.subItems);
      const id = item.id ? item.id : item.name;
      refs[id] = React.createRef();

      return (
        <Popover
          hoverEnable={!isFocused}
          clickTrigger
          position="right-start"
          submenu
          noPadding
          key={item.id ? item.id : item.name}
          openClass={bindClasses('active')}
          activatorElement={generateItemInner(item, checked, true)}
          ref={refs[id]}
          dataId={`SearchSelectionList_${item.id ? item.id : item.name}`}
        >
          <FilteredSelectInner
            onItemSelected={onItemSelected}
            items={item.subItems}
            onFocus={onFocus}
            onBlur={onBlur}
            isItemChecked={isItemChecked}
            onOpen={() => { closeOtherElements(id); }}
          />
        </Popover>
      );
    }
    const checked = isItemChecked(item);

    return generateItemInner(item, checked, false);
  };

  return (
    <Popover.Section>
      <div className={bindClasses('wrapper')}>
        {
          isLoading
            ? <Spinner className="medium" />
            : (
              <div
                className={bindClasses('group')}
              >
                <ul className={bindClasses('items')}>
                  {items.map(generateItem)}
                </ul>
              </div>
            )
        }
      </div>
    </Popover.Section>
  );
};

export default SearchSelectionListInner;
